/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  GetPaymentRequestInfoT,
  getPaymentRequestInfoDefaultDecoder,
  NewTransactionT,
  newTransactionDefaultDecoder,
  GetTransactionInfoT,
  getTransactionInfoDefaultDecoder,
  RequestTransactionUserCancellationT,
  requestTransactionUserCancellationDefaultDecoder,
  GetTransactionOutcomesT,
  getTransactionOutcomesDefaultDecoder,
  RequestTransactionAuthorizationT,
  requestTransactionAuthorizationDefaultDecoder,
  GetAllPaymentMethodsT,
  getAllPaymentMethodsDefaultDecoder,
  GetPaymentMethodT,
  getPaymentMethodDefaultDecoder,
  CalculateFeesT,
  calculateFeesDefaultDecoder,
  CreateSessionT,
  createSessionDefaultDecoder,
  GetSessionPaymentMethodT,
  getSessionPaymentMethodDefaultDecoder,
  GetCartsT,
  GetCartsDefaultDecoder,
  GetCartsRedirectT,
  GetCartsRedirectDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<GetPaymentRequestInfoT> &
  TypeofApiCall<NewTransactionT> &
  TypeofApiCall<GetTransactionInfoT> &
  TypeofApiCall<RequestTransactionUserCancellationT> &
  TypeofApiCall<GetTransactionOutcomesT> &
  TypeofApiCall<RequestTransactionAuthorizationT> &
  TypeofApiCall<GetAllPaymentMethodsT> &
  TypeofApiCall<GetPaymentMethodT> &
  TypeofApiCall<CalculateFeesT> &
  TypeofApiCall<CreateSessionT> &
  TypeofApiCall<GetSessionPaymentMethodT> &
  TypeofApiCall<GetCartsT> &
  TypeofApiCall<GetCartsRedirectT>;

export type ParamKeys = keyof (TypeofApiParams<GetPaymentRequestInfoT> &
  TypeofApiParams<NewTransactionT> &
  TypeofApiParams<GetTransactionInfoT> &
  TypeofApiParams<RequestTransactionUserCancellationT> &
  TypeofApiParams<GetTransactionOutcomesT> &
  TypeofApiParams<RequestTransactionAuthorizationT> &
  TypeofApiParams<GetAllPaymentMethodsT> &
  TypeofApiParams<GetPaymentMethodT> &
  TypeofApiParams<CalculateFeesT> &
  TypeofApiParams<CreateSessionT> &
  TypeofApiParams<GetSessionPaymentMethodT> &
  TypeofApiParams<GetCartsT> &
  TypeofApiParams<GetCartsRedirectT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | GetPaymentRequestInfoT
  | NewTransactionT
  | GetTransactionInfoT
  | RequestTransactionUserCancellationT
  | GetTransactionOutcomesT
  | RequestTransactionAuthorizationT
  | GetAllPaymentMethodsT
  | GetPaymentMethodT
  | CalculateFeesT
  | CreateSessionT
  | GetSessionPaymentMethodT
  | GetCartsT
  | GetCartsRedirectT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly getPaymentRequestInfo: TypeofApiCall<GetPaymentRequestInfoT>;

      readonly newTransaction: TypeofApiCall<NewTransactionT>;

      readonly getTransactionInfo: TypeofApiCall<GetTransactionInfoT>;

      readonly requestTransactionUserCancellation: TypeofApiCall<
        RequestTransactionUserCancellationT
      >;

      readonly getTransactionOutcomes: TypeofApiCall<GetTransactionOutcomesT>;

      readonly requestTransactionAuthorization: TypeofApiCall<
        RequestTransactionAuthorizationT
      >;

      readonly getAllPaymentMethods: TypeofApiCall<GetAllPaymentMethodsT>;

      readonly getPaymentMethod: TypeofApiCall<GetPaymentMethodT>;

      readonly calculateFees: TypeofApiCall<CalculateFeesT>;

      readonly createSession: TypeofApiCall<CreateSessionT>;

      readonly getSessionPaymentMethod: TypeofApiCall<GetSessionPaymentMethodT>;

      readonly GetCarts: TypeofApiCall<GetCartsT>;

      readonly GetCartsRedirect: TypeofApiCall<GetCartsRedirectT>;
    }
  : {
      readonly getPaymentRequestInfo: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentRequestInfoT,
          Omit<RequestParams<GetPaymentRequestInfoT>, K>
        >
      >;

      readonly newTransaction: TypeofApiCall<
        ReplaceRequestParams<
          NewTransactionT,
          Omit<RequestParams<NewTransactionT>, K>
        >
      >;

      readonly getTransactionInfo: TypeofApiCall<
        ReplaceRequestParams<
          GetTransactionInfoT,
          Omit<RequestParams<GetTransactionInfoT>, K>
        >
      >;

      readonly requestTransactionUserCancellation: TypeofApiCall<
        ReplaceRequestParams<
          RequestTransactionUserCancellationT,
          Omit<RequestParams<RequestTransactionUserCancellationT>, K>
        >
      >;

      readonly getTransactionOutcomes: TypeofApiCall<
        ReplaceRequestParams<
          GetTransactionOutcomesT,
          Omit<RequestParams<GetTransactionOutcomesT>, K>
        >
      >;

      readonly requestTransactionAuthorization: TypeofApiCall<
        ReplaceRequestParams<
          RequestTransactionAuthorizationT,
          Omit<RequestParams<RequestTransactionAuthorizationT>, K>
        >
      >;

      readonly getAllPaymentMethods: TypeofApiCall<
        ReplaceRequestParams<
          GetAllPaymentMethodsT,
          Omit<RequestParams<GetAllPaymentMethodsT>, K>
        >
      >;

      readonly getPaymentMethod: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentMethodT,
          Omit<RequestParams<GetPaymentMethodT>, K>
        >
      >;

      readonly calculateFees: TypeofApiCall<
        ReplaceRequestParams<
          CalculateFeesT,
          Omit<RequestParams<CalculateFeesT>, K>
        >
      >;

      readonly createSession: TypeofApiCall<
        ReplaceRequestParams<
          CreateSessionT,
          Omit<RequestParams<CreateSessionT>, K>
        >
      >;

      readonly getSessionPaymentMethod: TypeofApiCall<
        ReplaceRequestParams<
          GetSessionPaymentMethodT,
          Omit<RequestParams<GetSessionPaymentMethodT>, K>
        >
      >;

      readonly GetCarts: TypeofApiCall<
        ReplaceRequestParams<GetCartsT, Omit<RequestParams<GetCartsT>, K>>
      >;

      readonly GetCartsRedirect: TypeofApiCall<
        ReplaceRequestParams<
          GetCartsRedirectT,
          Omit<RequestParams<GetCartsRedirectT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const getPaymentRequestInfoT: ReplaceRequestParams<
    GetPaymentRequestInfoT,
    RequestParams<GetPaymentRequestInfoT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getPaymentRequestInfoDefaultDecoder(),
    url: ({ ["rpt_id"]: rptId }) => `${basePath}/payment-requests/${rptId}`,

    query: ({ ["recaptchaResponse"]: recaptchaResponse }) =>
      withoutUndefinedValues({ ["recaptchaResponse"]: recaptchaResponse })
  };
  const getPaymentRequestInfo: TypeofApiCall<GetPaymentRequestInfoT> = createFetchRequestForApi(
    getPaymentRequestInfoT,
    options
  );

  const newTransactionT: ReplaceRequestParams<
    NewTransactionT,
    RequestParams<NewTransactionT>
  > = {
    method: "post",

    headers: () => ({
      "Content-Type": "application/json"
    }),
    response_decoder: newTransactionDefaultDecoder(),
    url: ({}) => `${basePath}/transactions`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: ({ ["recaptchaResponse"]: recaptchaResponse }) =>
      withoutUndefinedValues({ ["recaptchaResponse"]: recaptchaResponse })
  };
  const newTransaction: TypeofApiCall<NewTransactionT> = createFetchRequestForApi(
    newTransactionT,
    options
  );

  const getTransactionInfoT: ReplaceRequestParams<
    GetTransactionInfoT,
    RequestParams<GetTransactionInfoT>
  > = {
    method: "get",

    headers: ({ ["bearerAuth"]: bearerAuth }) => ({
      Authorization: `Bearer ${bearerAuth}`
    }),
    response_decoder: getTransactionInfoDefaultDecoder(),
    url: ({ ["transactionId"]: transactionId }) =>
      `${basePath}/transactions/${transactionId}`,

    query: () => withoutUndefinedValues({})
  };
  const getTransactionInfo: TypeofApiCall<GetTransactionInfoT> = createFetchRequestForApi(
    getTransactionInfoT,
    options
  );

  const requestTransactionUserCancellationT: ReplaceRequestParams<
    RequestTransactionUserCancellationT,
    RequestParams<RequestTransactionUserCancellationT>
  > = {
    method: "delete",

    headers: ({ ["bearerAuth"]: bearerAuth }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "Content-Type": "application/json"
    }),
    response_decoder: requestTransactionUserCancellationDefaultDecoder(),
    url: ({ ["transactionId"]: transactionId }) =>
      `${basePath}/transactions/${transactionId}`,

    query: () => withoutUndefinedValues({})
  };
  const requestTransactionUserCancellation: TypeofApiCall<RequestTransactionUserCancellationT> = createFetchRequestForApi(
    requestTransactionUserCancellationT,
    options
  );

  const getTransactionOutcomesT: ReplaceRequestParams<
    GetTransactionOutcomesT,
    RequestParams<GetTransactionOutcomesT>
  > = {
    method: "get",

    headers: ({ ["bearerAuth"]: bearerAuth }) => ({
      Authorization: `Bearer ${bearerAuth}`
    }),
    response_decoder: getTransactionOutcomesDefaultDecoder(),
    url: ({ ["transactionId"]: transactionId }) =>
      `${basePath}/transactions/${transactionId}/outcomes`,

    query: () => withoutUndefinedValues({})
  };
  const getTransactionOutcomes: TypeofApiCall<GetTransactionOutcomesT> = createFetchRequestForApi(
    getTransactionOutcomesT,
    options
  );

  const requestTransactionAuthorizationT: ReplaceRequestParams<
    RequestTransactionAuthorizationT,
    RequestParams<RequestTransactionAuthorizationT>
  > = {
    method: "post",

    headers: ({ ["bearerAuth"]: bearerAuth, ["lang"]: lang }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      lang: lang,

      "Content-Type": "application/json"
    }),
    response_decoder: requestTransactionAuthorizationDefaultDecoder(),
    url: ({ ["transactionId"]: transactionId }) =>
      `${basePath}/transactions/${transactionId}/auth-requests`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const requestTransactionAuthorization: TypeofApiCall<RequestTransactionAuthorizationT> = createFetchRequestForApi(
    requestTransactionAuthorizationT,
    options
  );

  const getAllPaymentMethodsT: ReplaceRequestParams<
    GetAllPaymentMethodsT,
    RequestParams<GetAllPaymentMethodsT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getAllPaymentMethodsDefaultDecoder(),
    url: ({}) => `${basePath}/payment-methods`,

    query: ({ ["amount"]: amount }) =>
      withoutUndefinedValues({ ["amount"]: amount })
  };
  const getAllPaymentMethods: TypeofApiCall<GetAllPaymentMethodsT> = createFetchRequestForApi(
    getAllPaymentMethodsT,
    options
  );

  const getPaymentMethodT: ReplaceRequestParams<
    GetPaymentMethodT,
    RequestParams<GetPaymentMethodT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getPaymentMethodDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentMethod: TypeofApiCall<GetPaymentMethodT> = createFetchRequestForApi(
    getPaymentMethodT,
    options
  );

  const calculateFeesT: ReplaceRequestParams<
    CalculateFeesT,
    RequestParams<CalculateFeesT>
  > = {
    method: "post",

    headers: ({
      ["bearerAuth"]: bearerAuth,
      ["x-transaction-id-from-client"]: xTransactionIdFromClient
    }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-transaction-id-from-client": xTransactionIdFromClient,

      "Content-Type": "application/json"
    }),
    response_decoder: calculateFeesDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}/fees`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: ({ ["maxOccurrences"]: maxOccurrences }) =>
      withoutUndefinedValues({ ["maxOccurrences"]: maxOccurrences })
  };
  const calculateFees: TypeofApiCall<CalculateFeesT> = createFetchRequestForApi(
    calculateFeesT,
    options
  );

  const createSessionT: ReplaceRequestParams<
    CreateSessionT,
    RequestParams<CreateSessionT>
  > = {
    method: "post",

    headers: ({ ["lang"]: lang }) => ({
      lang: lang,

      "Content-Type": "application/json"
    }),
    response_decoder: createSessionDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}/sessions`,

    body: () => "{}",

    query: () => withoutUndefinedValues({})
  };
  const createSession: TypeofApiCall<CreateSessionT> = createFetchRequestForApi(
    createSessionT,
    options
  );

  const getSessionPaymentMethodT: ReplaceRequestParams<
    GetSessionPaymentMethodT,
    RequestParams<GetSessionPaymentMethodT>
  > = {
    method: "get",

    headers: ({
      ["bearerAuth"]: bearerAuth,
      ["x-transaction-id-from-client"]: xTransactionIdFromClient
    }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-transaction-id-from-client": xTransactionIdFromClient
    }),
    response_decoder: getSessionPaymentMethodDefaultDecoder(),
    url: ({ ["id"]: id, ["orderId"]: orderId }) =>
      `${basePath}/payment-methods/${id}/sessions/${orderId}`,

    query: () => withoutUndefinedValues({})
  };
  const getSessionPaymentMethod: TypeofApiCall<GetSessionPaymentMethodT> = createFetchRequestForApi(
    getSessionPaymentMethodT,
    options
  );

  const GetCartsT: ReplaceRequestParams<GetCartsT, RequestParams<GetCartsT>> = {
    method: "get",

    headers: () => ({}),

    response_decoder: GetCartsDefaultDecoder(),
    url: ({ ["id_cart"]: idCart }) => `${basePath}/carts/${idCart}`,

    query: () => withoutUndefinedValues({})
  };
  const GetCarts: TypeofApiCall<GetCartsT> = createFetchRequestForApi(
    GetCartsT,
    options
  );

  const GetCartsRedirectT: ReplaceRequestParams<
    GetCartsRedirectT,
    RequestParams<GetCartsRedirectT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: GetCartsRedirectDefaultDecoder(),
    url: ({ ["cart_id"]: cartId }) => `${basePath}/carts/${cartId}/redirect`,

    query: () => withoutUndefinedValues({})
  };
  const GetCartsRedirect: TypeofApiCall<GetCartsRedirectT> = createFetchRequestForApi(
    GetCartsRedirectT,
    options
  );

  return {
    getPaymentRequestInfo: (withDefaults || identity)(getPaymentRequestInfo),
    newTransaction: (withDefaults || identity)(newTransaction),
    getTransactionInfo: (withDefaults || identity)(getTransactionInfo),
    requestTransactionUserCancellation: (withDefaults || identity)(
      requestTransactionUserCancellation
    ),
    getTransactionOutcomes: (withDefaults || identity)(getTransactionOutcomes),
    requestTransactionAuthorization: (withDefaults || identity)(
      requestTransactionAuthorization
    ),
    getAllPaymentMethods: (withDefaults || identity)(getAllPaymentMethods),
    getPaymentMethod: (withDefaults || identity)(getPaymentMethod),
    calculateFees: (withDefaults || identity)(calculateFees),
    createSession: (withDefaults || identity)(createSession),
    getSessionPaymentMethod: (withDefaults || identity)(
      getSessionPaymentMethod
    ),
    GetCarts: (withDefaults || identity)(GetCarts),
    GetCartsRedirect: (withDefaults || identity)(GetCartsRedirect)
  };
}
